// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*\nOn smaller screens where there is the bottom nav, the intercom\nbutton is pushed up so it doesn't overlap the bottom nav.\nNote: still overlapping when we have two bottom navs (e.g. on\ncash wallet screen and the bitcoin wallet screen)\n*/\n@media (max-width: 659px) {\n  .intercom-lightweight-app-launcher {\n    /*\n    bottom nav height is 62px and intercom is usually 20px from bottom\n    62px + 20px = 82px\n    */\n    bottom: 82px !important;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
